import Tooltip from '@/components/ui/Tooltip/Tooltip';

export { default as TCITooltip } from './TCITooltip';

export default Tooltip;
